const DEFAULT_SPEED = .2;

export default (gsap: typeof import('gsap').gsap): () => void => {
  const init = (el: HTMLElement) => {
    const speed = el.dataset.speed ? parseFloat(el.dataset.speed) : DEFAULT_SPEED;

    const factor = 1 / Math.max(speed, 0.0001);
    const rangeX = 40 * factor; // px
    const rangeY = 60 * factor; // px

    gsap.to(el, {
      x: () => rangeX,
      y: () => rangeY,
      ease: 'none',
      scrollTrigger: {
        trigger: document.documentElement,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
        markers: window.location.host === 'x.ddev.site',
        invalidateOnRefresh: true,
      },
    });
  };

  (document.querySelectorAll('.shape-image') as NodeListOf<HTMLElement>).forEach(init);

  return () => {
    gsap.set('.shape-image', {
      x: 0,
      y: 0,
    });
  };
};
